import { toast } from 'sonner';

import { cn } from '@/lib/utils';

export type ToastVariant = 'success' | 'error' | 'copySuccess';

type SonnerOptions = NonNullable<Parameters<typeof toast>[1]>;

const baseToastStyles = 'group-[.toaster]:border-none!';

const toastVariants: Record<ToastVariant, SonnerOptions> = {
  success: {
    classNames: {
      toast: cn(baseToastStyles, 'bg-success-subtle! text-success!'),
    },
  },
  error: {
    classNames: {
      toast: cn(baseToastStyles, 'bg-destructive-subtle! text-destructive!'),
    },
  },
  copySuccess: {
    classNames: {
      toast:
        'font-medium! text-sm! group-[.toaster]:min-w-fit! group-[.toaster]:w-auto! group-[.toaster]:rounded-lg! group-[.toaster]:shadow-md! group-[.toaster]:mb-4! group-[.toaster]:mr-4! group-[.toaster]:gap-3! group-[.toaster]:pr-12! group-[.toaster]:bg-background! group-[.toaster]:text-foreground! group-[.toaster]:border-border!',
      icon: 'text-success',
      closeButton:
        '!left-auto !right-2 !top-1/2  !bg-transparent !border-none  !text-muted-foreground',
    },
  },
};

type ShowToastType = {
  variant: ToastVariant;
  title: string;
  options?: SonnerOptions;
};

const showToast = ({ variant, title, options }: ShowToastType) => {
  const variantOptions = toastVariants[variant];

  const { classNames: variantClassNames, ...restOfVariantOptions } = variantOptions;
  const { classNames: optionClassNames, ...restOfOptions } = options || {};

  const mergedClassNames: SonnerOptions['classNames'] = {
    ...variantClassNames,
    ...optionClassNames,
    toast: cn(variantClassNames?.toast, optionClassNames?.toast),
    description: cn(variantClassNames?.description, optionClassNames?.description),
    icon: cn(variantClassNames?.icon, optionClassNames?.icon),
    closeButton: cn(variantClassNames?.closeButton, optionClassNames?.closeButton),
  };

  const isCopySuccess = variant === 'copySuccess';
  const toastFn = isCopySuccess ? toast.success : toast[variant as 'success' | 'error'];

  return toastFn(title, {
    ...restOfVariantOptions,
    ...restOfOptions,
    closeButton: isCopySuccess,
    dismissible: isCopySuccess,
    classNames: mergedClassNames,
  });
};

export default showToast;
